import type { ComponentProps } from 'react';
import { cn } from '@/lib/cn';

export function Input({ className, type = 'text', ...props }: ComponentProps<'input'>) {
  return (
    <input
      type={type}
      className={cn(
        'h-10 w-full min-w-0 rounded-md border border-border-strong bg-surface-raised px-3 text-sm text-foreground shadow-sm transition-colors duration-150 placeholder:text-muted-foreground focus-visible:border-brand focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-ring/40 disabled:cursor-not-allowed disabled:opacity-60 aria-invalid:border-status-red-solid',
        className,
      )}
      {...props}
    />
  );
}
